<template>
  <AppLabel
    :key="configData.BgColor + configData.Text"
    :color="configData.BgColor"
    :text="textFormatted"
  />
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';

interface Props {
  configData: {
    Text: string;
    BgColor: string;
  };
}
const props = defineProps<Props>();

const textFormatted = computed(() => {
  let text = props.configData?.Text || '';
  text = markup_markdownLikeTextToHtmlString(text);
  return text;
});
</script>

<style scoped></style>
